import { Icon, Popup } from "semantic-ui-react"
import type { OpenAPI } from "simplydo/interfaces"

import { socialMediaLinks } from "components/users/Details/ProfileLink"
import { useAppSelector } from "store"

type SocialLinksProps = {
  user: OpenAPI.Schemas["User"]
}

export const SocialLinks = ({ user }: SocialLinksProps) => {
  const currentUser = useAppSelector((state) => state.user)

  const hasProfile = user?.profile
  if (!hasProfile) {
    user = {
      profile: {
        fullName: "Unknown User",
      },
    }
  }

  const org = currentUser?.ownerOrganisation

  const profileSocialElements = hasProfile
    ? ["linkedin", "website", "facebook", "instagram", "github", "twitter"].filter((key) => !!user?.profile[key])
    : []

  return (
    <div style={{ display: "flex", alignItems: "center", marginLeft: 5 }}>
      {!user?.profile?.linkedin &&
        currentUser._id === user._id &&
        org?.superadminTags?.innovationType === "externalInnovation" && (
          <Popup
            content={
              <p>
                <Icon name="linkedin" />
                Add your LinkedIn
              </p>
            }
            trigger={
              <a href="/preferences/profile" onClick={(e) => e.stopPropagation()}>
                <Icon name="linkedin" style={{ marginLeft: "4px", marginBottom: "2px", color: "#8a8e90ff" }} />
              </a>
            }
          />
        )}

      {profileSocialElements.map((socialElement) => {
        const link = user?.profile[socialElement]
        if (!link) return null
        const fullLink =
          link.startsWith("https://") || link.startsWith("www.") ? link : socialMediaLinks[socialElement].link + link

        return (
          <a
            key={socialElement}
            href={fullLink}
            target="blank"
            onClick={(e) => e.stopPropagation()}
            rel="noreferrer noopenner"
          >
            {socialMediaLinks[socialElement].icon && (
              <Icon
                style={{ color: socialMediaLinks[socialElement].color }}
                name={socialMediaLinks[socialElement].icon}
              />
            )}
            {socialMediaLinks[socialElement].iconLeftAlt && (
              <span style={{ fontSize: "1.15em", color: "black", padding: "0 0.1em" }}>
                {socialMediaLinks[socialElement].iconLeftAlt}
              </span>
            )}
          </a>
        )
      })}
    </div>
  )
}
